module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welfare"
  }, [_c('div', {
    ref: "label",
    staticClass: "label",
    style: ({
      transform: ("translateY(" + _vm.translateY + "px)")
    })
  }, [_c('div', {
    staticClass: "label-name"
  }, [_vm._v("WELFARE")])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.images.welfareBanner
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "welfare-blocks"
  }, [_c('ContentBlock', {
    attrs: {
      "hasUnderLine": "true",
      "labelName": "Welfare",
      "labelNo": "01",
      "enTitle": "Workshop",
      "contentImg": _vm.images.welfareWorkshop,
      "contentText": "新芽同事們臥虎藏龍，透過工作坊共同分享、討論技術或行銷新知。也可以提出有興趣的內容，邀請外部講師來上課。"
    }
  }), _vm._v(" "), _c('ContentBlock', {
    attrs: {
      "hasUnderLine": "true",
      "labelName": "Welfare",
      "labelNo": "02",
      "enTitle": "Sprouters' Outing",
      "contentImg": _vm.images.welfareOuting,
      "contentText": "年度國內旅行，快樂玩耍促進團隊情誼，也回顧該年大事紀，並訂定下一年目標。"
    }
  }), _vm._v(" "), _c('ContentBlock', {
    attrs: {
      "hasUnderLine": "true",
      "labelName": "Welfare",
      "labelNo": "03",
      "enTitle": "Movie Night",
      "contentImg": _vm.images.welfareMovie,
      "contentText": "每季一次的電影之夜，一起觀賞當季最受矚目的電影。"
    }
  }), _vm._v(" "), _c('ContentBlock', {
    attrs: {
      "hasUnderLine": "true",
      "labelName": "Welfare",
      "labelNo": "04",
      "enTitle": "Sprouters' Day",
      "contentImg": _vm.images.sproutersDay,
      "contentText": "每月一次大家一起討論公司大小事，所有夥伴都可以參與討論、共同打造新芽組織文化。"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4fa3adf6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sectionWork/Welfare.vue
// module id = 676
// module chunks = 0